var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tooltip",class:_vm.rootClasses},[_c('div',{staticClass:"ui-tooltip__transformer"},[_c('div',{staticClass:"ui-tooltip__inner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }